export default __webpack_public_path__ + "static/media/Bell.99104d63.svg";